export const getSelectedFiltersFromUrl = (location) => {
    if (!location) return
    const searchParams = new URLSearchParams(location.search)
    if (!searchParams) return
    const selectedFilters = {}
    for (const [key, value] of searchParams.entries()) {
        selectedFilters[key] = value.split(',').map((v) => ({contentstackValue: v}))
    }
    return selectedFilters
}

export const removeFilter = (location, history, filter) => {
    if (!location || !filter) return

    const searchParams = new URLSearchParams(location.search)

    for (const key of searchParams.keys()) {
        const values = searchParams.get(key).split(',')
        const newValues = values.filter((v) => v !== filter.contentstackValue)

        if (newValues.length > 0) {
            searchParams.set(key, newValues.join(','))
        } else {
            searchParams.delete(key)
        }
    }

    history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
    })
}
export const clearAllFilters = (location, history) => {
    if (!location || !history) return
    const searchParams = new URLSearchParams()

    history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
    })
}
